/**
 * @desc 返回颜色
 * @param {订单} order
 */
export function statusColor (order) {
  let str = ''
  switch (order.status) {
    case '0':
      return '#FF9F0E'
    case '1':
      return '#2F82FF'
    case '2':
      return '#808690'
    case '3':
      if (order.refundStatus === '0') {
        return '#FF2A58'
      }
      if (order.refundStatus === '1') {
        return '#0ABA50'
      }
      if (order.refundStatus === '2') {
        return '#2F82FF'
      }
      if (order.refundStatus === '3') {
        return '#0ABA50'
      }
      return '退款'
    case 'cancel':
      return '#A9AFB9'
  }
  return str
}

/**
 * @desc 返回颜色
 * @param {订单} order
 */
export function refundStatusColor (order) {
  let str = ''
  switch (order.refundStatus) {
    case '0':
      return '#FFAB2C'
    case '1':
      return '#0ABA50'
    case '2':
      return '#FF2A58'
    case '3':
      return '#0ABA50'
    case 'cancel':
      return '#A9AFB9'
  }
  return str
}

export const formatDate = (time) => {
  var date = new Date(time)

  var year = date.getFullYear()
  var month = date.getMonth() + 1; var // 月份是从0开始的
    day = date.getDate()
  var newTime = year + '-' + (month > 10 ? month : ('0' + month)) + '-' + (day > 10 ? day : ('0' + day))
  return newTime
}

export const getDayAll = (starDay, endDay) => {
  var arr = []
  var dates = []

  // 设置两个日期UTC时间
  var db = new Date(starDay)
  var de = new Date(endDay)

  // 获取两个日期GTM时间
  var s = db.getTime() - 24 * 60 * 60 * 1000
  var d = de.getTime() - 24 * 60 * 60 * 1000

  // 获取到两个日期之间的每一天的毫秒数
  for (var i = s; i <= d;) {
    i = i + 24 * 60 * 60 * 1000
    arr.push(parseInt(i))
  }

  // 获取每一天的时间  YY-MM-DD
  var arrNull = []
  for (var j in arr) {
    var time = new Date(arr[j])
    var year = time.getFullYear(time)
    var mouth = (time.getMonth() + 1) >= 10 ? (time.getMonth() + 1) : ('0' + (time.getMonth() + 1))
    var day = time.getDate() >= 10 ? time.getDate() : ('0' + time.getDate())
    var YYMMDD = year + '-' + mouth + '-' + day
    dates.push(YYMMDD)
    arrNull.push(0)
  }

  return [dates, arrNull]
}
